import React from "react";
import { usePlayer } from "@empirica/core/player/classic/react";
import { CompletionLink } from "./CompletionLink";
import { getCounterpartCopy } from "../payoffFrame";

export function QueueWaitingStage() {
  const player = usePlayer();
  const counterpart = getCounterpartCopy(player.get("queueTreatment") || {});

  return (
    <div className="flex min-h-screen w-full items-start justify-center px-6 py-10">
      <div className="w-full max-w-lg rounded-md border border-gray-200 bg-white p-6 text-center shadow-sm">
        <div className="mx-auto mb-5 h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-empirica-600" />
        <h1 className="text-2xl font-semibold text-gray-900">
          Waiting for {counterpart.article} {counterpart.term}
        </h1>
        <p className="mt-3 text-base text-gray-700">
          The experiment will continue automatically when another ready participant is available.
        </p>
      </div>
    </div>
  );
}

export function QueueTimedOutStage() {
  const player = usePlayer();
  const counterpart = getCounterpartCopy(player.get("queueTreatment") || {});

  return (
    <div className="flex min-h-screen w-full items-start justify-center px-6 py-10">
      <div className="w-full max-w-xl space-y-5 text-center">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">
            No {counterpart.term} was available
          </h1>
          <p className="mt-3 text-base text-gray-700">
            We could not match you with another participant in time.
          </p>
        </div>
        <CompletionLink partial embedded />
      </div>
    </div>
  );
}
